(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    if (window.__gdCollectionLoaded) return;
    window.__gdCollectionLoaded = true;

    var esc = function (s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    };
    var key = function (s) {
      return String(s || '')
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    };
    var lines = function (s) {
      return (s || '').split(/\r?\n/).map(function (l) { return l.trim(); }).filter(Boolean);
    };
    var toRe = function (p) {
      return new RegExp('^' + key(p).replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '.*') + '$');
    };
    var area = function (s) {
      var n = String(s).match(/\d+(\.\d+)?/g);
      if (!n) return null;
      if (n.length >= 2) return n[n.length - 2] * n[n.length - 1];
      return +n[0];
    };
    var parseJson = function (v) { try { return JSON.parse(v) || []; } catch (e) { return []; } };

    function init(root) {
      if (root.__gdReady) return;
      root.__gdReady = true;

      var d = root.dataset;
      var $ = function (s) { return root.querySelector(s); };
      var grid = $('[data-gd-grid]');
      if (!grid) return;
      var catBox = $('[data-gd-cats]');
      var sizeBox = $('[data-gd-sizes]');
      var sizeWrap = $('[data-gd-size-wrap]');
      var countEl = $('[data-gd-count]');
      var sortEl = $('[data-gd-sort]');
      var sentinel = $('[data-gd-sentinel]');
      var moreWrap = $('[data-gd-morewrap]');
      var moreBtn = $('[data-gd-more]');
      var emptyEl = $('[data-gd-empty]');
      var sidebar = $('[data-gd-sidebar]');
      var overlay = $('[data-gd-overlay]');
      var clearSide = $('[data-gd-clear-side]');
      var applyBtn = $('[data-gd-apply]');

      var uid = d.gdRoot;
      var batch = parseInt(d.batch, 10) || 12;
      var infinite = d.infinite === 'true' && 'IntersectionObserver' in window;
      var pages = parseInt(d.pages, 10) || 1;
      var cur = parseInt(d.currentPage, 10) || 1;
            var showCatCount = d.catCounts === 'true';
      var showSizeCount = d.sizeCounts === 'true';
      var allLabel = d.allLabel || 'All Products';
      var countText = d.countText || 'Showing 1-{shown} of {total} products';
      var applyText = d.applyText || 'Show results';
      var addedText = d.addedText || 'Added';
      var atcMode = d.atcMode || 'smart';

      var alias = {}, order = [];
      lines(d.catList).forEach(function (l) {
        var p = l.split('|');
        var k = key(p[0]);
        order.push(k);
        if (p[1] && p[1].trim()) alias[k] = p[1].trim();
      });
      var hide = lines(d.catHide).map(toRe);

      var labels = {}, pool = [];
      var loading = true;
      var loadedPages = {};
      loadedPages[cur] = true;
      var state = { cat: 'all', sizes: [], sort: 'featured', shown: batch };

      var qs = new URLSearchParams(location.search);
      if (qs.get('cat')) state.cat = key(qs.get('cat')) || 'all';
      state.sizes = qs.getAll('size').map(key).filter(Boolean);
      if (qs.get('sort')) state.sort = qs.get('sort');
      if (sortEl) {
        sortEl.value = state.sort;
        if (sortEl.value !== state.sort) { state.sort = 'featured'; sortEl.value = 'featured'; }
      }

      function parse(el) {
        if (el.__gd) return el.__gd;
        var cats = parseJson(el.dataset.cats);
        var rawSizes = parseJson(el.dataset.sizes);
        var rawVariants = parseJson(el.dataset.variants);
        var o = {
          el: el,
          idx: +el.dataset.index || 0,
          price: +el.dataset.price || 0,
          created: +el.dataset.created || 0,
          title: el.dataset.title || '',
          cats: cats.map(function (c) { return key(c); }).filter(Boolean),
          sizes: rawSizes.map(function (s) { return key(s); }).filter(Boolean),
          variants: rawVariants.map(function (v) {
            return { id: v.id, a: !!v.a, size: v.size == null ? null : key(v.size) };
          })
        };
        cats.forEach(function (c) { var k = key(c); if (!labels[k]) labels[k] = String(c).trim(); });
        el.__gd = o;
        return o;
      }

      function collect() {
        Array.prototype.forEach.call(grid.children, function (el) {
          if (el.classList && el.classList.contains('gd-card') && !el.__gd) pool.push(parse(el));
        });
      }

      function inCat(p) {
        return state.cat === 'all' || p.cats.indexOf(key(state.cat)) > -1;
      }
      function inSize(p) {
        if (!state.sizes.length) return true;
        return p.sizes.some(function (s) { return state.sizes.indexOf(key(s)) > -1; });
      }

      function sizeData() {
        var counts = {}, labels = {}, list = [];
        pool.filter(inCat).forEach(function (p) {
          p.sizes.forEach(function (s) {
            var k = key(s);
            if (!k) return;
            if (counts[k] == null) { counts[k] = 0; list.push(k); }
            labels[k] = labels[k] || String(s);
            counts[k]++;
          });
        });
        list = list.map(function (s, i) { return { s: s, i: i, a: area(s) }; })
          .sort(function (a, b) {
            if (a.a !== null && b.a !== null && a.a !== b.a) return a.a - b.a;
            return a.i - b.i;
          })
          .map(function (o) { return o.s; });
        return { list: list, counts: counts, labels: labels };
      }

      function opt(type, name, value, label, count, checked) {
        return '<li><label class="gd-opt"><input type="' + type + '" name="' + esc(name) + '" value="' + esc(value) + '"' +
          (checked ? ' checked' : '') + '><span class="gd-opt__label">' + esc(label) + '</span>' +
          (count != null ? '<span class="gd-opt__count">(' + count + ')</span>' : '') + '</label></li>';
      }

      function renderFilters() {
        if (catBox) {
          var counts = {};
          pool.forEach(function (p) { p.cats.forEach(function (k) { counts[k] = (counts[k] || 0) + 1; }); });
          var items = [];
          if (order.length) {
            order.forEach(function (k) { if (k) items.push(k); });
          } else {
            items = Object.keys(counts)
              .filter(function (k) { return !hide.some(function (r) { return r.test(k); }); })
              .sort(function (a, b) { return counts[b] - counts[a] || a.localeCompare(b); });
          }
          var h = opt('radio', 'gd-cat-' + uid, 'all', allLabel, showCatCount ? pool.length : null, state.cat === 'all');
          items.forEach(function (k) {
            h += opt('radio', 'gd-cat-' + uid, k, alias[k] || labels[k] || k, showCatCount ? counts[k] : null, state.cat === k);
          });
          catBox.innerHTML = h;
        }
        if (sizeBox && sizeWrap) {
          var sd = sizeData();
          var sh = '';
          sd.list.forEach(function (s) {
            sh += opt('checkbox', 'gd-size-' + uid, s, sd.labels[s] || s, showSizeCount ? sd.counts[s] : null, state.sizes.indexOf(s) > -1);
          });
          sizeBox.innerHTML = sh;
          sizeWrap.hidden = sd.list.length === 0;
        }
      }

      var io = null;
      if (infinite && sentinel) {
        io = new IntersectionObserver(function (es) {
          if (es[0].isIntersecting) more();
        }, { rootMargin: '700px 0px' });
      }

      function more() {
        if (loading) return;
        state.shown += batch;
        renderGrid();
      }

      function paintWl() {
        var list = wl();
        root.querySelectorAll('[data-gd-wish]').forEach(function (b) {
          var on = list.indexOf(b.getAttribute('data-gd-wish')) > -1;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      function wl() { try { return JSON.parse(localStorage.getItem('gd_wishlist')) || []; } catch (e) { return []; } }
      function saveWl(a) { try { localStorage.setItem('gd_wishlist', JSON.stringify(a)); } catch (e) {} }

      function syncUrl() {
        try {
          var u = new URL(location.href);
          u.searchParams.delete('cat'); u.searchParams.delete('size'); u.searchParams.delete('sort');
          if (state.cat !== 'all') u.searchParams.set('cat', state.cat);
          state.sizes.forEach(function (s) { u.searchParams.append('size', s); });
          if (state.sort !== 'featured') u.searchParams.set('sort', state.sort);
          history.replaceState(null, '', u.toString());
        } catch (e) {}
      }

      function renderGrid() {
        var list = pool.filter(function (p) { return inCat(p) && inSize(p); });
        var s = state.sort;
        list.sort(function (a, b) {
          if (s === 'price-asc') return a.price - b.price || a.idx - b.idx;
          if (s === 'price-desc') return b.price - a.price || a.idx - b.idx;
          if (s === 'newest') return b.created - a.created || a.idx - b.idx;
          if (s === 'title-asc') return a.title.localeCompare(b.title) || a.idx - b.idx;
          if (s === 'title-desc') return b.title.localeCompare(a.title) || a.idx - b.idx;
          return a.idx - b.idx;
        });
        pool.forEach(function (p) { p.el.hidden = true; });
        list.forEach(function (p, i) {
          p.el.style.order = i;
          p.el.hidden = i >= state.shown;
        });

        var shown = Math.min(state.shown, list.length);
        if (countEl) {
          countEl.textContent = list.length
            ? countText.replace('{shown}', shown).replace('{total}', list.length)
            : '';
        }
        if (emptyEl) emptyEl.hidden = !(list.length === 0 && !loading);
        var hasMore = state.shown < list.length;
        var waitingForPages = loading && pages > Object.keys(loadedPages).length;
        if (sentinel) sentinel.hidden = !((hasMore || waitingForPages) && infinite);
        if (moreWrap) moreWrap.hidden = !(hasMore && !loading && !infinite);
        if (io && sentinel) {
          io.unobserve(sentinel);
          if (hasMore) io.observe(sentinel);
        }
        if (clearSide) clearSide.hidden = !(state.cat !== 'all' || state.sizes.length);
        if (applyBtn) applyBtn.textContent = applyText.replace('{n}', list.length);
        paintWl();
        syncUrl();
      }

      function pick(p) {
        var vs = p.variants.filter(function (v) { return v.a; });
        if (!vs.length) return null;

        /* When a size filter is active, prefer a matching available
           variant. Otherwise add the first available variant. */
        if (state.sizes.length) {
          var m = vs.filter(function (v) {
            return v.size && state.sizes.indexOf(v.size) > -1;
          });
          if (m.length) return m[0];
        }

        return vs[0];
      }

      function updateCartUI(cart) {
        var n = cart.item_count;
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart, sourceId: 'gd-collection', data: { source: 'gd-collection', itemCount: n } }
          }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
        } catch (e) {}
        document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .cart-bubble__text-count').forEach(function (el) {
          el.textContent = n;
        });
      }

      function addToCart(btn) {
        var card = btn.closest('.gd-card');
        var p = card && card.__gd;
        if (!p) return;
        var v = pick(p);
        if (!v) {
          var unavailableLabel = btn.querySelector('.gd-atc__label');
          if (unavailableLabel) unavailableLabel.textContent = 'Unavailable';
          return;
        }
        if (btn.classList.contains('is-busy')) return;
        btn.classList.add('is-busy');
        var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var lab = btn.querySelector('.gd-atc__label');
        var old = lab ? lab.textContent : '';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
          .then(function (cart) {
            if (lab) lab.textContent = addedText;
            btn.classList.add('is-added');
            updateCartUI(cart);
            setTimeout(function () {
              if (lab) lab.textContent = old;
              btn.classList.remove('is-added', 'is-busy');
            }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-busy');
            btn.classList.remove('is-added');
            if (lab) {
              lab.textContent = 'Try again';
              setTimeout(function () { lab.textContent = old; }, 1800);
            }
          });
      }

      function drawer(open) {
        if (!sidebar) return;
        sidebar.classList.toggle('is-open', open);
        if (overlay) overlay.classList.toggle('is-open', open);
        document.documentElement.classList.toggle('gd-lock', open);
      }

      function clearAll() {
        state.cat = 'all';
        state.sizes = [];
        state.shown = batch;
        renderFilters();
        renderGrid();
      }

      root.addEventListener('change', function (e) {
        var t = e.target;
        if (t.name === 'gd-cat-' + uid) {
          state.cat = key(t.value) || 'all';
          state.shown = batch;
          var avail = sizeData().list;
          state.sizes = state.sizes.filter(function (x) { return avail.indexOf(x) > -1; });
          renderFilters();
          renderGrid();
        } else if (t.name === 'gd-size-' + uid) {
          state.sizes = Array.prototype.map.call(
            root.querySelectorAll('input[name="gd-size-' + uid + '"]:checked'),
            function (i) { return key(i.value); }
          ).filter(Boolean);
          state.shown = batch;
          renderGrid();
        }
      });

      root.addEventListener('click', function (e) {
        var t = e.target;
        var filterInput = t.closest('input[name="gd-cat-' + uid + '"], input[name="gd-size-' + uid + '"]');
        if (filterInput) {
          setTimeout(function () {
            if (filterInput.name === 'gd-cat-' + uid) {
              state.cat = key(filterInput.value) || 'all';
              state.shown = batch;
              var avail = sizeData().list;
              state.sizes = state.sizes.filter(function (x) { return avail.indexOf(x) > -1; });
              renderFilters();
              renderGrid();
            } else {
              state.sizes = Array.prototype.map.call(
                root.querySelectorAll('input[name="gd-size-' + uid + '"]:checked'),
                function (i) { return key(i.value); }
              ).filter(Boolean);
              state.shown = batch;
              renderGrid();
            }
          }, 0);
          return;
        }
        var atc = t.closest('[data-gd-atc]');
        if (atc) { e.preventDefault(); addToCart(atc); return; }
        var wish = t.closest('[data-gd-wish]');
        if (wish) {
          e.preventDefault();
          var h = wish.getAttribute('data-gd-wish');
          var list = wl();
          var i = list.indexOf(h);
          if (i > -1) list.splice(i, 1); else list.push(h);
          saveWl(list);
          paintWl();
          document.dispatchEvent(new CustomEvent('gd:wishlist', { detail: { handle: h, active: i === -1, list: list } }));
          return;
        }
        if (t.closest('[data-gd-clear]')) { clearAll(); return; }
        if (t.closest('[data-gd-open]')) { drawer(true); return; }
        if (t.closest('[data-gd-close]') || t.closest('[data-gd-apply]') || t.closest('[data-gd-overlay]')) { drawer(false); return; }
        if (t.closest('[data-gd-more]') && !t.closest('[data-gd-clear]')) { more(); }
      });

      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });

      if (sortEl) {
        sortEl.addEventListener('change', function () {
          state.sort = sortEl.value;
          state.shown = batch;
          renderGrid();
        });
      }

      function loadPages() {
        var nextPage = 1;
        var allUrl = d.allUrl || location.pathname;
        var allPath = '';
        try { allPath = new URL(allUrl, location.origin).pathname; } catch (e) { allPath = allUrl; }
        var currentPath = location.pathname;
        var catalogPages = null;

        function appendGrid(doc) {
          var g = doc.querySelector('[data-gd-grid]');
          if (!g) throw new Error('Collection grid missing');
          Array.prototype.slice.call(g.children).forEach(function (li) {
            if (!li.classList || !li.classList.contains('gd-card')) return;
            var productId = li.id || li.getAttribute('data-url') || '';
            if (productId) {
              var existing = Array.prototype.some.call(grid.children, function (oldLi) {
                return oldLi.id === productId;
              });
              if (existing) return;
            }
            li.hidden = true;
            grid.appendChild(document.adoptNode(li));
          });
          var rootData = doc.querySelector('[data-gd-root="' + uid + '"]');
          if (rootData) {
            var n = parseInt(rootData.getAttribute('data-pages'), 10);
            if (n) catalogPages = n;
          }
          collect();
          renderFilters();
          renderGrid();
        }

        function fetchPage(path, n, sectionOnly) {
          var u = new URL(path, location.origin);
          u.searchParams.set('page', n);
          if (sectionOnly) u.searchParams.set('section_id', uid);
          else u.searchParams.delete('section_id');
          return fetch(u.toString(), {
            credentials: 'same-origin',
            headers: sectionOnly ? { 'X-Requested-With': 'XMLHttpRequest' } : {},
            cache: 'no-store'
          }).then(function (r) {
            if (!r.ok) throw new Error('Page ' + n + ' failed: ' + r.status);
            return r.text();
          });
        }

        function finishIfDone() {
          if (catalogPages && nextPage > catalogPages) {
            loading = false;
            renderFilters();
            renderGrid();
            return true;
          }
          return false;
        }

        function next() {
          if (finishIfDone()) return;

          var n = nextPage++;
          if (loadedPages[n]) { next(); return; }

          fetchPage(allUrl, n, true)
            .then(function (t) {
              var doc = new DOMParser().parseFromString(t, 'text/html');
              appendGrid(doc);
              loadedPages[n] = true;
              next();
            })
            .catch(function () {
              fetchPage(allUrl, n, false)
                .then(function (t) {
                  var doc = new DOMParser().parseFromString(t, 'text/html');
                  appendGrid(doc);
                  loadedPages[n] = true;
                  next();
                })
                .catch(function () {
                  /* Keep the failed page pending so a later retry can recover. */
                  nextPage = Math.max(1, n);
                  loading = true;
                  renderFilters();
                  renderGrid();
                });
            });
        }

        /*
         * Always build the filter/product pool from the store-wide All Products
         * collection. This is important when the visitor is currently on a
         * category collection: the sidebar must still contain every category,
         * and choosing another category must switch products without navigating
         * to a different template.
         */
        if (currentPath !== allPath) {
          catalogPages = null;
          nextPage = 1;
        } else {
          catalogPages = pages;
          nextPage = 1;
        }
        next();
      }

      collect();
      renderFilters();
      renderGrid();
      if (loading) loadPages();
    }

    function boot() { document.querySelectorAll('[data-gd-root]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
